import { PRODUCT_IDS } from "../registry";
import { getProductIdForPath } from "../routing";

const envNameFor = (productId) =>
  `REACT_APP_PRODUCT_${productId.replace(/[A-Z]/g, (match) => `_${match}`).toUpperCase()}_ENABLED`;

const readEnabledFlag = (productId) => {
  const raw = process.env[envNameFor(productId)];
  if (typeof raw !== "string") return true;

  const normalized = raw.trim().toLowerCase();
  return !["0", "false", "off", "no"].includes(normalized);
};

export const PRODUCT_FLAGS = PRODUCT_IDS.reduce((acc, productId) => {
  acc[productId] = readEnabledFlag(productId);
  return acc;
}, {});

export const isProductEnabled = (productId) =>
  Object.prototype.hasOwnProperty.call(PRODUCT_FLAGS, productId)
    ? PRODUCT_FLAGS[productId]
    : false;

export const isPathProductEnabled = (pathname) => {
  const productId = getProductIdForPath(pathname);
  if (!productId) return true;
  return isProductEnabled(productId);
};
